import {ALL_SHOWER_AREA_GROUPS, ALL_VANITY_AREA_GROUPS} from "../look/core/constants";

// Shared between UiPopupAIContentFeaturesAreas, aiFunctions, aiActions and aiAsyncActions.
// Lives in its own file (rather than the popup component) to avoid circular imports.
export const FEATURE_AREAS: {featureArea: string, partIds: string[]}[] = [
  {featureArea: "Wet Area", partIds: [...new Set<string>(ALL_SHOWER_AREA_GROUPS)]},
  {featureArea: "Vanity Area", partIds: [...new Set<string>(ALL_VANITY_AREA_GROUPS)]},
];
